var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVerima(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "601.3px",
    height: "260.9px",
    viewBox: "0 0 601.3 260.9",
    style: {
      enableBackground: "new 0 0 601.3 260.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#083746;}\n\t.st2{fill:#80E8CC;}\n\t.st3{fill:#0F6E8C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,147.7c-3.6,14.9-17.8,21.7-32.2,21.7c-4.8,0-9.3-0.6-13.3-1.8l32.9-19.9H240.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.1,104.5v20.3c-3.1-1.7-6-2.1-9.5-2.1c-12.5,0-15.6,8.3-15.6,19.1v25.5h-22.4v-34L299.1,104.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.5,
    y: 104,
    className: "st1",
    width: 22.5,
    height: 63.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.1,127v40.3h-22.5v-30.2c0-6.5,0.2-17.3-9.3-17.3c-10.4,0-10.7,9.8-10.7,17.3v30.2h-22.5v-30.2 c0-7,0-17.8-10-17.8c-10,0-10,10.7-10,17.8v30.2h-22.5V104h22.5v7.9h0.2c5.3-7,11.8-10,20-10c9.1,0,17,3.7,21.6,12.1 c4.3-7.9,12.8-12.1,21.5-12.1C446.5,101.9,452.1,112.4,452.1,127z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M513.6,104v6.2c-4.7-5.5-12.3-8.3-19.6-8.3c-18.8,0-31.7,15.5-31.7,33.7c0,18.2,13.2,33.8,32,33.8 c7.4,0,15.2-2.8,19.1-9.1h0.2v7H536V104H513.6z M499.9,149.9c-9.1,0-14.4-6.2-14.4-14.2c0-7.8,5.3-14.3,14.4-14.3 c9.1,0,14.4,6.5,14.4,14.3C514.3,143.8,509,149.9,499.9,149.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.7,65.3H130.5c-36,0-65.1,29.2-65.1,65.1c0,36,29.2,65.1,65.1,65.1c12.6,0,24.4-3.6,34.4-9.8v0l30.1-18.2 c-13.9-4.1-23.3-15-23.3-31.9c0-21.1,14.4-33.8,35-33.8c22,0,34.7,13.6,34.7,35.2v2.3h-47.2c0,9.1,4.8,14.1,14.1,14.1 c4.8,0,8.3-1.6,10.7-5.8h8.9l23.8-14.4V104H274v10.4h0.2c4.3-7.8,11.7-11.2,20.5-11.2h4.3v1.3l25.7-15.6c1.9-1.1,3.6-2.6,4.7-4.5 c1.1-1.9,1.8-4.1,1.8-6.5C331.3,70.9,325.7,65.3,318.7,65.3z M137.7,167.3h-14.3L90.2,104h25.2l15.2,32.4l15-32.4h25.2 L137.7,167.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M220.5,126.5h-26c1.4-6.5,6.8-10,13.3-10C213.8,116.5,219.4,120.4,220.5,126.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "170.7,104 137.7,167.3 123.4,167.3 90.2,104 115.4,104 130.5,136.5 145.6,104  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.3,137.1c0-21.6-12.7-35.2-34.7-35.2c-20.6,0-35,12.7-35,33.8c0,16.9,9.3,27.8,23.3,31.9l32.9-19.9h-8.9 c-2.5,4.2-5.9,5.8-10.7,5.8c-9.3,0-14.1-4.9-14.1-14.1h47.2V137.1z M194.5,126.5c1.4-6.5,6.8-10,13.3-10c6,0,11.6,3.9,12.7,10 H194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.1,103.2v1.3l-47.5,28.8V104H274v10.4h0.2c4.3-7.8,11.7-11.2,20.5-11.2H299.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerima);
export default __webpack_public_path__ + "static/media/logo_verima.feaa4242c81c0c25aecc95be879f8c06.svg";
export { ForwardRef as ReactComponent };